export const PlusIcon = () => {
    return (
        <>
            <title>Add</title>
            <path d="M440-440H200v-80h240v-240h80v240h240v80H520v240h-80v-240Z" />
        </>
    );
};
